export const MessageIcon = ({ className = "" }: { className?: string }) => {
  return (
    <svg
      role="img"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Message Icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.1666 3.16666V14.1667C22.1666 14.896 21.8769 15.5955 21.3612 16.1112C20.8454 16.6269 20.146 16.9167 19.4166 16.9167H12.5416L5.66663 22.4167V16.9167H2.91663C2.18728 16.9167 1.48781 16.6269 0.972082 16.1112C0.456357 15.5955 0.166626 14.896 0.166626 14.1667V3.16666C0.166626 2.43731 0.456357 1.73784 0.972082 1.22211C1.48781 0.706388 2.18728 0.416656 2.91663 0.416656H19.4166C20.146 0.416656 20.8454 0.706388 21.3612 1.22211C21.8769 1.73784 22.1666 2.43731 22.1666 3.16666ZM7.04163 7.29166H4.29163V10.0417H7.04163V7.29166ZM9.79163 7.29166H12.5416V10.0417H9.79163V7.29166ZM18.0416 7.29166H15.2916V10.0417H18.0416V7.29166Z"
        className={className}
        fill="currentColor"
      />
    </svg>
  );
};
